import { __name } from './chunk-Q72B4Q5Z.mjs';
import assert from 'node:assert';

function isCompatDate(str) {
  return /^\d{4}-\d{2}-\d{2}$/.test(str);
}
__name(isCompatDate, "isCompatDate");
function formatCompatibilityDate(date) {
  const compatDate = date.toISOString().slice(0, 10);
  assert(isCompatDate(compatDate));
  return compatDate;
}
__name(formatCompatibilityDate, "formatCompatibilityDate");
function getTodaysCompatDate() {
  return formatCompatibilityDate(/* @__PURE__ */ new Date());
}
__name(getTodaysCompatDate, "getTodaysCompatDate");
var NODEJS_COMPAT_DEFAULT_ON_DATE = "2026-08-04";
function isNodejsCompatDefaultOn(compatibilityDate) {
  return compatibilityDate !== void 0 && compatibilityDate >= NODEJS_COMPAT_DEFAULT_ON_DATE;
}
__name(isNodejsCompatDefaultOn, "isNodejsCompatDefaultOn");
var NODEJS_COMPAT_V2_SWITCH_OVER_DATE = "2024-09-23";
function resolveNodejsCompat(compatibilityDate, compatibilityFlags) {
  const isDefaultOn = isNodejsCompatDefaultOn(compatibilityDate);
  const isNodejsCompatEnabled = compatibilityFlags.includes("nodejs_compat") || isDefaultOn && !compatibilityFlags.includes("no_nodejs_compat");
  const isNodejsCompatV2Enabled = compatibilityFlags.includes("nodejs_compat_v2") || !compatibilityFlags.includes("no_nodejs_compat_v2") && (isDefaultOn || isNodejsCompatEnabled && compatibilityDate >= NODEJS_COMPAT_V2_SWITCH_OVER_DATE);
  return { isNodejsCompatEnabled, isNodejsCompatV2Enabled };
}
__name(resolveNodejsCompat, "resolveNodejsCompat");
function stripRedundantNodejsCompatFlags(compatibilityDate, compatibilityFlags) {
  if (!isNodejsCompatDefaultOn(compatibilityDate)) {
    return compatibilityFlags;
  }
  const redundantFlags = ["nodejs_compat", "nodejs_compat_v2"].filter(
    (flag) => !compatibilityFlags.includes(`no_${flag}`)
  );
  return compatibilityFlags.filter((flag) => !redundantFlags.includes(flag));
}
__name(stripRedundantNodejsCompatFlags, "stripRedundantNodejsCompatFlags");

export { NODEJS_COMPAT_DEFAULT_ON_DATE, NODEJS_COMPAT_V2_SWITCH_OVER_DATE, getTodaysCompatDate, isCompatDate, isNodejsCompatDefaultOn, resolveNodejsCompat, stripRedundantNodejsCompatFlags };
